import React from 'react';
import { Footer, Input } from 'components/layout';
import { useForm, FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { night, ocean, cyberpunk } from 'assets/colors';
import packageJson from '../../../package.json';
import { useStyle } from './styles';
import { useTheme } from '@mui/material/styles';
import { loginPolicies } from 'helpers';
import {
  Box,
  Grid,
  Typography,
  Paper
} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import { Logo, LanguageButton } from 'components/common';

import LineDraw from './LineDraw';
import './styles.css'
import Cube from './Cube';
import CubesAnimation from './CubesAnimation';


const LoginDumb = ({ isLoaded, handleFormSubmit }) => {
  const [t] = useTranslation();
  const classes = useStyle();
  const methods = useForm({ defaultValues: { username: '', password: '', rememberMe: false } });
  const theme = useTheme();
  const { handleSubmit, control } = methods;

  const fields = [
    { policy: loginPolicies.username },
    { policy: loginPolicies.password },
    // { policy: loginPolicies.rememberMe }
  ];

  const size = 170;

  const faceColorFirst = [
    {top: ocean[500], bot: ocean[500]},
    {mid: cyberpunk[500]},
    {top: ocean[500], bot: ocean[500]}
  ];

  const faceColorSecond = [
    {mid: cyberpunk[500]},
    {top: cyberpunk[500], bot: cyberpunk[500]},
    {mid: cyberpunk[500]},
  ];

  function ColumnCube({ sx, colorPattern, id }) {
    const colors = { top: "#ACCAF7", mid: "#ACCAF7", bot: "#ACCAF7", ...colorPattern };

    return (
      <Box sx={sx}>
        <Cube id={`${id}-top`} sx={{ color: colors.top, zIndex: 3, position: 'absolute', top: 0, left: 0 }}/>
        <Cube id={`${id}-mid`} sx={{ color: colors.mid, zIndex: 2, position: 'absolute', top: size / 2, left: 0 }}/>
        <Cube id={`${id}-bot`} sx={{ color: colors.bot, zIndex: 1, position: 'absolute', top: size / 1, left: 0 }}/>
      </Box>
    );
  }

  function FaceCube({ sx, colorPattern=[], id }) {
    return (
      <Box sx={sx}>
        <ColumnCube id={`${id}-left`} sx={{ zIndex: 1, position: 'absolute', top: 0, left: 0, width: size / 1, height: size }} colorPattern={colorPattern[0]}/>
        <ColumnCube id={`${id}-mid`} sx={{ zIndex: 2, position: 'absolute', top: size / 4, left: size / 2, width: size, height: size }} colorPattern={colorPattern[1]}/>
        <ColumnCube id={`${id}-right`} sx={{ zIndex: 3, position: 'absolute', top: size / 2, left: size / 1, width: size, height: size }} colorPattern={colorPattern[2]}/>
      </Box>
    );
  }

  function ComponentCube({ sx }) {
    return (
      <Box sx={sx}>
        <FaceCube
          sx={{ zIndex: 3, position: 'absolute', top: 0, left: 0 }}
          colorPattern={faceColorFirst}
          id="front"
        />
        <FaceCube
          sx={{ zIndex: 2, position: 'absolute', top: (size / 4) * -1, left: size / 2 }}
          colorPattern={faceColorSecond}
          id="mid"
        />
        <FaceCube
          sx={{ zIndex: 1, position: 'absolute', top: (size / 2) * -1, left: size / 1 }}
          colorPattern={faceColorFirst}
          id="back"
        />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        backgroundColor: night['500'],
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        backgroundImage: `radial-gradient(farthest-corner at 120% 150%, ${ocean[500]} 40%, white)`,
        overflow: 'hidden'
      }}
    >
      <Grid container sx={{ height: '100%', width: '100%' }}>

        <Grid
          item
          xs={12}
          sm={12}
          md={8}
          lg={6}
          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 8 }}
        >
          <Box sx={{ display: 'flex', gap: 4, alignItems: 'center' }}>
            <Logo className={classes.logo} primaryColor={night[500]}/>
            <Typography variant="h1" sx={{ mb: 2, color: night[500], fontFamily: 'monospace', fontWeight: '400' }}>
              {packageJson.name}
            </Typography>
          </Box>

          <Paper className={classes.paperStyle}>
            <Typography variant="h3" sx={{ mb: 2 }}>
              {t('login.headline')}
            </Typography>

            <FormProvider { ...methods }>
              <form onSubmit={handleSubmit(handleFormSubmit)}>
                <Grid container spacing={4} sx={{ display: 'flex', flexDirection: 'column' }}>
                  {fields.map((field) => (
                    <Grid key={field.policy.id} item>
                      <Input
                        {...field.policy}
                        control={control}
                        sx={{ width: '100%' }}
                        disabled={isLoaded}
                      />
                    </Grid>
                  ))}
                  <Grid item>
                    <LoadingButton variant="contained" size='large' sx={{ width: '100%' }} type="submit" loading={isLoaded}>
                      {t('login.components.submit')}
                    </LoadingButton>
                  </Grid>
                </Grid>
              </form>
            </FormProvider>
          </Paper>
        </Grid>

        <Grid item xs={0} sm={0} md={4} lg={6} sx={{ position: 'relative', height: '100%' }}>
          <ComponentCube

            sx={{ position: 'absolute', top: '38%', right: '78%', widht: '100%' }}
          />
          <Box sx={{ height: '100vh', position: 'absolute', overflow: 'hidden', opacity: 0.8, left: 0, zIndex: 0 }}>
            <LineDraw sx={{ height: '100%' }}/>
          </Box>
        </Grid>


      </Grid>

      <Box sx={{ position: 'absolute', right: 0, top: '12px'}}>
        <LanguageButton/>
      </Box>

      <Box sx={{ width: '100%', overflow: 'hidden', zIndex: '1' }}>
        <Footer />
      </Box>
    </Box>
  );
}

export default LoginDumb;
